/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ matched: NonNullable<unknown>, inserted: NonNullable<unknown>, skipped: NonNullable<unknown> }} Event_Group_Sync_Status_CompleteInputs */



/**
* | output |
* | --- |
* | "Synced {matched} events. Inserted {inserted}. Skipped {skipped}." |
*
* @param {Event_Group_Sync_Status_CompleteInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const event_group_sync_status_complete = /** @type {((inputs: Event_Group_Sync_Status_CompleteInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Event_Group_Sync_Status_CompleteInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Synced ${i?.matched} events. Inserted ${i?.inserted}. Skipped ${i?.skipped}.`)
	if (locale === "de") return /** @type {LocalizedString} */ (`Synced ${i?.matched} events. Inserted ${i?.inserted}. Skipped ${i?.skipped}.`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Synced ${i?.matched} events. Inserted ${i?.inserted}. Skipped ${i?.skipped}.`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`Synced ${i?.matched} events. Inserted ${i?.inserted}. Skipped ${i?.skipped}.`)
	if (locale === "es") return /** @type {LocalizedString} */ (`Synced ${i?.matched} events. Inserted ${i?.inserted}. Skipped ${i?.skipped}.`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`Synced ${i?.matched} events. Inserted ${i?.inserted}. Skipped ${i?.skipped}.`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`Synced ${i?.matched} events. Inserted ${i?.inserted}. Skipped ${i?.skipped}.`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`Synced ${i?.matched} events. Inserted ${i?.inserted}. Skipped ${i?.skipped}.`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`Synced ${i?.matched} events. Inserted ${i?.inserted}. Skipped ${i?.skipped}.`)
	return /** @type {LocalizedString} */ (`Synced ${i?.matched} events. Inserted ${i?.inserted}. Skipped ${i?.skipped}.`)
});